import styled from "styled-components";

const DeleteText = styled.span`
  cursor: pointer;
  color: darkgrey;

  &:hover {
    color: black;
  }
`;

export default DeleteText;
